import axios from 'axios';

export default {
    install(Vue, options) {
        if (!options) {
            options = {};
        }


        Vue.prototype.$getAjaxErrorString = (error) => {

            if (error instanceof axios.Cancel) {
                return;
            }

            if (error.response) {

                switch (typeof error.response.data) {
                    case 'string':

                        return error.response.data;
                    case 'object':
                        if (typeof error.response.data.errors === 'object') {

                            return _.find(error.response.data.errors)[0];
                        }
                }

            }

            return "Oops, something went wrong!";
        }

    }
}
